export var getAttendanceColor = function getAttendanceColor(attendance) {
  var color = '#fff';
  if (attendance != null) {
    if (attendance.attendanceType == 'PRESENT') {
      color = '#19DB6C';
    } else if (attendance.attendanceType == 'INVALID_ABSENCE') {
      color = '#F25252';
    } else if (attendance.attendanceType == 'ABSENT') {
      color = '#F25252';
    } else if (attendance.attendanceType == 'VALID_ABSENCE') {
      color = '#FF883E';
    } else if (attendance.attendanceType == 'INVALID_LATE') {
      color = '#F2527D';
    } else if (attendance.attendanceType == 'LATE') {
      color = '#F2527D';
    } else if (attendance.attendanceType == 'VALID_LATE') {
      color = '#EFC24C';
    } else if (attendance.attendanceType == 'OTHER_ACTIVITY') {
      color = '#FF883E';
    } else if (attendance.attendanceType == 'OTHER_ACTIVITY_PARTIAL') {
      color = '#EFC24C';
    }
  }
  return color;
};